
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.33 1.917H4.25a1.42 1.42 0 00-1.416 1.416v11.334c0 .779.637 1.416 1.417 1.416h8.5a1.42 1.42 0 001.416-1.416V6.753c0-.375-.15-.736-.415-1.001l-3.42-3.42a1.417 1.417 0 00-1.001-.415zm1.95 11.12c-.171.401-.512.573-.91.459-.34-.115-.738-.403-1.136-.862-.397.058-.795.173-1.192.287-.455.804-.91 1.494-1.364 1.666a.743.743 0 01-.341.08c-.228 0-.398-.08-.512-.252-.113-.173-.34-.518.114-1.034.284-.345.965-.69 1.704-.919.227-.46.397-.918.568-1.435-.397-.747-.625-1.551-.568-2.01.057-.461.35-.725.739-.725.39 0 .624.264.738.666.114.46 0 1.207-.284 2.068.171.345.398.689.625 1.033.682-.057 1.25-.057 1.591.172.284.173.34.46.227.805zM9.208 6.874V2.979l3.896 3.896H9.209z","fill":"#667187"}})])
          )
        }
      }
    